import { InjectionToken } from '@angular/core';

export enum EntityStoreKey {
  featureFlags = 'featureFlags',
}

export type FeatureFlagsMap = Record<FeatureFlag, boolean>;
export const FEATURE_FLAGS = new InjectionToken<FeatureFlagsMap>('Feature flags map');

export enum FeatureFlag {
  BetaTesters = 'beta-testers',
  DisableZiggeo = 'disable-ziggeo',
  Referrals = 'referrals', // This flag should be migrated to pricing features after release
  NewCareers = 'new_careers',
  Billing = 'billing',
  EventDebug = 'debug_event_tracking',
  FairEvaluations = 'fair_evaluations',
  JobFitScore = 'job_fit_score',
  NotificationsPerRole = 'notifications_per_role',
  KnockoutQuestions = 'knockout_questions_flag',
}
